<template>
  <vs-popup id="popupSearchCompany" :title="popupTitle" :active.sync="showPopup">
    <vs-row class="text-center" style="border-bottom: 1px solid #e0e0e0">
      <vs-col class="w-10/12 flex" vs-align="center">
        <vs-col class="w-4/12 flex" vs-align="center">
          <span class="w-4/12">검색어</span>
          <ml-input class="w-8/12" v-model="search.keyword" @keyup.enter="handleClickSearch" />
        </vs-col>
      </vs-col>
      <vs-col class="w-2/12 text-right">
        <vs-button color="secondary" @click="handleClickSearch">검색</vs-button>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col class="mb-4">
        <vs-select v-model="page.perPage" autocomplete @input="handleClickSearch">
          <vs-select-item v-for="i in [10, 25, 50, 100]" :text="`${i}개씩 보기`" :value="i" />
        </vs-select>
      </vs-col>
      <vs-col style="max-height: 500px; overflow-y: auto">
        <vs-table stripe ref="table" :sst="true" :max-items="page.perPage" :data="companyList" noDataText="데이터가 없습니다" @selected="handleItemClickDetail" class="tableList">
          <template slot="thead">
            <vs-th class="">No.</vs-th>
            <vs-th class="">구분</vs-th>
            <vs-th class="">부서명</vs-th>
            <vs-th class="">연락처</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :class="multiple ? (selectCompanyIds.includes(company.id) ? 'active' : '') : selectCompany.id === company.id ? 'active' : ''" :data="company" :key="index" v-for="(company, index) in data">
              <vs-td style="width: 60px">{{ company.id }}</vs-td>
              <vs-td>{{ company.com_type }}</vs-td>
              <vs-td>{{ company.com_name }}</vs-td>
              <vs-td style="min-width: 140px">{{ company.phone }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <div class="vs-con-table">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination :total="page.lastPage ? page.lastPage : 0" v-model="page.current" @change="handleChangePage"></k-pagination>
          </div>
        </div>
      </vs-col>

      <vs-col class="mt-4 flex" vs-align="center" vs-justify="flex-end">
        <vs-button class="mr-4" color="#EDEDED" text-color="black" type="filled" @click="handleClickClose">닫기 </vs-button>
        <vs-button class="" color="secondary" @click="handleClickSelect">선택</vs-button>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
import KPagination from "@/components/kPagination/kPagination";
export default {
  name: "PopupSearchCompany",
  props: {
    value: Boolean,
    multiple: Boolean,
    selectId: [String, Number, Array],
    // 팝업이 열릴 때, 기존에 선택된 업체 정보
    preSelectedCompanies: {
      type: Array,
      default: () => [],
    },

    fieldId: {
      type: Number | null,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: { KPagination },
  data() {
    return {
      showPopup: this.value,

      oldSelectCompanyId: this.selectId,
      oldSelectCompany: this.multiple ? [] : {},
      selectCompany: this.multiple ? [] : {},

      companyList: [],

      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 50,
      },

      // 겅색
      search: {
        keyword: "", // 검색어
      },
    };
  },
  computed: {
    popupTitle() {
      return this.title ? this.title : "업체검색";
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    // companyList() {
    //   const info = this.$store.state.company.companyListInfo;
    //   const list = this.$store.state.company.companyList;
    //   this.page.current = info.current_page;
    //   this.page.perPage = info.per_page;
    //   this.page.lastPage = info.last_page;
    //
    //   return list;
    // },
    selectCompanyIds() {
      if (this.multiple) return this.selectCompany.map((company) => company.id);
    },
  },
  watch: {
    value(data) {
      this.showPopup = data;
      if (data) {
        if (this.multiple) {
          // selectedCompamy 목록에 preSelectedCompanies를 병합시킨다
          this.selectCompany = JSON.parse(JSON.stringify(this.oldSelectCompany));

          for (const company of this.preSelectedCompanies) {
            if (!this.selectCompanyIds.includes(company.id)) this.selectCompany.push(company);
          }
        } else {
          this.selectCompany = this.oldSelectCompany;
        }

        this.loadCompanyList();
      }
    },
    showPopup(data) {
      this.$emit("input", data);
    },
  },

  mounted() {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false;
        next(false);
        return;
      }
      next(true);
    });
    this.$once("hook:destroyed", () => {
      backButtonRouteGuard();
    });
  },

  methods: {
    async loadCompanyList() {
      const page = this.page.current;
      const perPage = this.page.perPage;
      const keyword = this.search.keyword;
      const projectId = this.projectId;

      let params = { page, perPage, keyword, projectId };
      if (this.fieldId) params = { ...params, fieldId: this.fieldId };

      await this.$store.dispatch("company/LOAD_COMPANY_LIST", params);

      const info = this.$store.state.company.companyListInfo;
      this.page.current = info.current_page;
      this.page.perPage = info.per_page;
      this.page.lastPage = info.last_page;

      this.companyList = this.$store.state.company.companyList;
    },

    handleClickSearch() {
      this.page.current = 1;

      this.loadCompanyList();
    },

    handleChangePage(page) {
      this.page.current = page;
      this.loadCompanyList();
    },

    handleItemClickDetail(data) {
      if (this.multiple) {
        if (this.selectCompanyIds.includes(data.id)) this.selectCompany = this.selectCompany.filter((company) => company.id !== data.id);
        else this.selectCompany.push(data);
      } else if (this.selectCompany === data) this.selectCompany = {};
      else this.selectCompany = data;
    },

    handleClickClose() {
      this.selectCompany = JSON.parse(JSON.stringify(this.oldSelectCompany));
      this.$emit("input", false);
      this.$emit("handleClickClose");
    },

    handleClickSelect() {
      this.oldSelectCompany = JSON.parse(JSON.stringify(this.selectCompany)); // 선택한 업체 저장
      this.oldSelectCompanyId = this.selectCompanyIds; // 선택한 업체 id 저장

      this.$emit("input", false);
      this.$emit("handleClickSelect", this.selectCompany);
    },
  },
};
</script>

<style>
#popupSearchCompany > .vs-popup {
  width: 860px !important;
}

#popupSearchCompany > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0;
  margin: 0;
}

#popupSearchCompany > .vs-popup > .vs-popup--content > .vs-row {
  padding: 24px;
}
</style>

<style scoped>
.table-layout {
  border: 1px solid #cdcdcd;
}

.table-layout .trow {
  border-bottom: 1px solid #cdcdcd;
}

.table-layout .tcol {
  border-right: 1px solid #cdcdcd;
}

.vs-con-table.stripe .tr-values.active {
  background: rgb(102, 112, 203) !important;
  color: #fff;
  font-width: bold;
}
</style>
<style scoped lang="scss">
.tableList ::v-deep {
  .vs-table-text {
    justify-content: center;
  }

  .vs-table--td {
    text-align: center;
  }
}
</style>
